import { ExternalE2EEKeyProvider } from 'livekit-client';
import { useMemo } from 'react';

import { decodePassphrase } from '@/shared/client-utils';

export function useSetupE2EE() {
    return useMemo(() => {
        const e2eePassphrase = decodePassphrase(location.hash.slice(1));
        const worker = e2eePassphrase
            ? new Worker(new URL('livekit-client/e2ee-worker', import.meta.url), { type: 'module' })
            : undefined;
        return { worker, e2eePassphrase, keyProvider: new ExternalE2EEKeyProvider() };
    }, []);
}
